import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@NgModule({ })
export class SvgIconsModule {
   constructor(
      private iconRegistry: MatIconRegistry,
      private sanitizer: DomSanitizer,
   ) { }

   public register( icon: string, path: string = 'assets/icons/' ) {
      if ( !icon ) { return; }

      this.iconRegistry.addSvgIcon(
         icon,
         this.sanitizer.bypassSecurityTrustResourceUrl( `${path}${icon}.svg` ));
   }
}
